import { render, staticRenderFns } from "./get-plan.vue?vue&type=template&id=c7901014&scoped=true"
import script from "./get-plan.vue?vue&type=script&lang=js"
export * from "./get-plan.vue?vue&type=script&lang=js"
import style0 from "./get-plan.vue?vue&type=style&index=0&id=c7901014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7901014",
  null
  
)

export default component.exports